<template>
  <svg
    :class="customStyle"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 13V6.24998M11 6.24998L14 9.24998M11 6.24998L8.00001 9.24998M5.75001 16C4.67944 16.0011 3.64353 15.6206 2.82831 14.9267C2.01309 14.2327 1.47196 13.2709 1.30212 12.2139C1.13227 11.1569 1.34484 10.074 1.90163 9.15958C2.45842 8.24519 3.32297 7.55927 4.34001 7.22498C4.07871 5.88615 4.34877 4.49818 5.09299 3.355C5.83722 2.21181 6.99718 1.40318 8.32723 1.10033C9.65727 0.79749 11.053 1.02422 12.2188 1.7325C13.3846 2.44078 14.2289 3.57501 14.573 4.89498C15.105 4.72196 15.6748 4.70114 16.218 4.83488C16.7612 4.96862 17.2562 5.25159 17.6471 5.65182C18.038 6.05206 18.3092 6.55362 18.43 7.09985C18.5509 7.64608 18.5166 8.21522 18.331 8.74298C19.1497 9.05569 19.833 9.64508 20.2626 10.4089C20.6921 11.1728 20.8407 12.0629 20.6826 12.9249C20.5245 13.7868 20.0697 14.5662 19.3971 15.1279C18.7244 15.6896 17.8763 15.9982 17 16H5.75001Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CloudUploadSmall',

  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
